export type SupervisorFieldTypes =
  | `driver_info`
  | `string`
  | `number`
  | `boolean`
  | `date`
  | `time`
  | `images`
  | `signature`
  | `location`
  | `url`
  | `email`
  | `time_windows`
  | `requires`;

export const supervisorStopFieldValues = {
  driver_info: `driver_info`,
  planned_arrival_time: `time`,
  estimated_arrival_time: `date`,
  planned_departure_time: `time`,
  estimated_departure_time: `date`,
  pin: `string`,
  additional_info: `string`,
  customer_text_field: `string`,
  execution_date: `date`,
  client_external_id: `string`,
  label: `string`,
  external_id: `string`,
  location: `location`,
  location_details: `string`,
  comments: `string`,
  reference_person: `string`,
  phone: `string`,
  email: `email`,
  url: `url`,
  weight: `number`,
  volume: `number`,
  time_windows: `time_windows`,
  requires: `requires`,
  cluster: `string`,
  reward: `number`,
  duration: `number`,
  max_delivery_time: `number`,
};

export type SupervisorStopFieldType = keyof typeof supervisorStopFieldValues;

export const supervisorStopCompletedValues = {
  comments: `string`,
  images: `images`,
  signature: `signature`,
  location: `location`,
  created_at: `date`,
};

export type SupervisorStopCompletedType = keyof typeof supervisorStopCompletedValues;

export const supervisorStopCanceledValues = {
  comments: `string`,
  cancel_reason: `string`,
  images: `images`,
  location: `location`,
  created_at: `date`,
};

export type SupervisorStopCanceledType = keyof typeof supervisorStopCanceledValues;

export const supervisorStopSurveyValues = {
  rating: `number`,
  rating_tag: `string`,
  comments: `string`,
};

export type SupervisorStopSurveyType = keyof typeof supervisorStopSurveyValues;
